import { Modal } from 'antd';
import styled from 'styled-components';

export const ManagementSealRequestWrapper = styled.div<{
  listdata: number;
}>`
  .management-seal-request_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
    flex-wrap: wrap;

    .management-seal-request_header-title {
      display: flex;
      align-items: center;

      button {
        width: 48px;
        height: 48px;
        background-color: #edeff1;
        border-radius: 100%;
        border: none;
        position: relative;
        cursor: pointer;

        svg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      h1 {
        margin-left: 16px;
        line-height: 46px;
        margin-bottom: 0;
      }
    }

    .management-seal-request_header-btn {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;

      .ant-btn {
        height: 48px;
        border-radius: 7px;
        font-weight: var(--font-bold);
        color: var(--color-primary);
        border-color: var(--color-primary);
        min-width: 160px;

        &:disabled,
        &.ant-btn-disabled {
          color: rgba(0, 0, 0, 0.25);
          background-color: #f5f5f5;
          border-color: #d9d9d9;
          cursor: not-allowed;
        }
      }
    }
  }

  .management-seal-request_form {
    margin-bottom: 20px;

    .ant-form-item {
      margin-bottom: 0;

      .ant-form-item-label {
        padding: 0 0 4px;

        label {
          font-weight: var(--font-normal);
        }
      }

      .ant-select-lg {
        height: 44px;
      }
    }

    .management-seal-request_form-filters-row {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      flex-wrap: wrap;

      .management-seal-request_search-btn.ant-btn {
        flex-shrink: 0;
        height: 44px;
        min-width: 88px;
        font-weight: 700;
        background-color: var(--color-primary);
        color: #ffffff;
        border: none;
        border-radius: 7px;
        &:hover {
          background-color: var(--color-hover-primary) !important;
          color: #ffffff !important;
        }
      }
    }

    .management-seal-request_form-session {
      width: auto;
    }

    .management-seal-request_form-company,
    .management-seal-request_form-store {
      width: 200px;
      min-width: 200px;
    }
  }

  .management-seal-request_edit-button {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    color: #344054;

    &:hover {
      background-color: #edf2f6 !important;
      color: #175cd3 !important;
    }

    .anticon {
      font-size: 18px;
    }
  }

  .management-seal-request_total {
    margin-top: 16px;
    margin-bottom: 0;
    text-align: right;
    font-size: var(--font-size-base);
    font-weight: var(--font-medium);

    span {
      font-weight: var(--font-bold);
      margin: 0 4px;
    }
  }
`;

// Shared modal wrapper for VAMS_PC_008_01 (数量編集ダイアログ) and VAMS_PC_008_02 (送信確認ダイアログ).
export const SealRequestModalWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
    margin-top: 0;
    border-top: 1px solid var(--color-border-primary, #e5e7eb);

    .ant-btn {
      min-width: 120px;
      height: 44px;
      font-weight: var(--font-bold);
      border-radius: 8px;
      margin-inline-start: 0 !important;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .seal-request-dialog_message {
    margin-bottom: 16px;
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
  }

  .seal-request-dialog_field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .seal-request-dialog_label {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    font-weight: var(--font-medium);
  }

  .seal-request-dialog_value {
    background: #f3f4f6;
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 6px;
    padding: 10px 14px;
    font-size: var(--font-size-base);
    font-weight: var(--font-medium);
    color: var(--color-text-primary, #111827);
    min-height: 42px;
    display: flex;
    align-items: center;
  }

  .seal-request-dialog_note {
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary, #6b7280);
    margin-top: 4px;
  }

  .seal-request-dialog_error {
    color: #ef4444;
    font-size: var(--font-size-sm);
    margin-top: 4px;
  }

  .seal-request-dialog_input--error .ant-input-number-input {
    border-color: #ef4444;
  }

  .ant-table-wrapper {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    overflow: hidden;
  }
`;
